import { ReactNode } from 'react'
import { StyleSheet, TouchableOpacity, View } from 'react-native'

import { DSColor } from '@ppwr/poker'

import { DS } from '../../design-system'

interface GameActionsProp {
  leftIcon: ReactNode
  leftIconBg: DSColor
  title: string
  rightIcon: ReactNode
  rightIconBg?: DSColor
  onSelectingOption: () => void
}

export const GameActions = ({ leftIcon, leftIconBg, title, rightIcon, onSelectingOption }: GameActionsProp) => {
  return (
    <TouchableOpacity style={styles.gameShortcut} onPress={onSelectingOption}>
      <View style={styles.leftContainer}>
        <DS.Frame bg={leftIconBg} style={styles.leftIconContainer}>
          {leftIcon}
        </DS.Frame>
        <DS.Text variant="Heading 4/Medium">{title}</DS.Text>
      </View>
      {rightIcon}
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  gameShortcut: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    width: '100%',
    gap: 12,
    backgroundColor: DS.palette['Global/White'],
    borderRadius: 40,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey']
  },
  leftIconContainer: {
    height: 32,
    width: 32,
    borderRadius: 50,
    alignItems: 'center',
    justifyContent: 'center'
  },
  leftContainer: {
    flexDirection: 'row',
    gap: 12,
    alignItems: 'center'
  }
})
